/**
 * Utility for checking password expiration
 */

import { ADMIN_PASSWORD_SESSION, ADMIN_SESSION, ADMIN_SSO_SESSION } from 'common/constants';

export const shouldReauthenticatePasswordlessSession = (passwordUpdatedAt: string | null): boolean => {
	const sessionId = localStorage.getItem(ADMIN_SESSION);
	if (passwordUpdatedAt !== null || !sessionId) return false;

	return (
		localStorage.getItem(ADMIN_SSO_SESSION) !== sessionId &&
		localStorage.getItem(ADMIN_PASSWORD_SESSION) !== sessionId
	);
};

/**
 * Check if password has expired
 * @param passwordUpdatedAt - ISO date string of last password update, or null
 * @returns true if the current password session is expired or has no password date
 */
export const isPasswordExpired = (passwordUpdatedAt: string | null): boolean => {
	const sessionId = localStorage.getItem(ADMIN_SESSION);
	const ssoSessionId = localStorage.getItem(ADMIN_SSO_SESSION);

	if (sessionId && sessionId === ssoSessionId) {
		return false;
	}

	if (!passwordUpdatedAt) {
		return true;
	}

	try {
		const passwordDate = new Date(passwordUpdatedAt);
		const expirationDateThreshold = new Date();

		// Set to 6 months ago for production
		expirationDateThreshold.setMonth(expirationDateThreshold.getMonth() - 6);

		// Set date to 1min ago for testing purposes
		// expirationDateThreshold.setMinutes(expirationDateThreshold.getMinutes() - 1);

		return passwordDate < expirationDateThreshold;
	} catch {
		console.warn('Invalid passwordUpdatedAt date format:', passwordUpdatedAt);
		return true;
	}
};
